/* Petgraf: cursor em círculo v2 (Motion Vogel, 10/10/2026). Só mouse, só ponteiro fino, nunca com movimento reduzido.
   O anel some (cursor nativo volta) em campos, iframes, carrosséis, faixas com rolagem horizontal, avaliações, social e data-pgc-off.
   Posição por requestAnimationFrame com lerp, só translate. Sem ícone: só o anel cresce. */
(function () {
  'use strict';
  var d = document;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var mqR = matchMedia('(prefers-reduced-motion: reduce)');
  if (mqR.matches) return;
  function init() {
    var c = d.createElement('div'); c.className = 'pgc'; c.setAttribute('aria-hidden', 'true');
    d.body.appendChild(c);
    var x = 0, y = 0, tx = 0, ty = 0, raf = 0, on = false;
    var FIELD = 'input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=range]),textarea,select,[contenteditable=""],[contenteditable="true"],iframe,video[controls]';
    var ZONES = '[data-pgc-off],.pg-tool-table-wrap,.pg-reviews-viewport,.pg-reviews-track,.pg-story-track,.pg-trust-marquee,.pg-trust-track,pg-collection-carousel,pg-process-story,[class*="carousel"],[class*="marquee"]';
    var LINK = 'a[href],button,label,summary,[role="button"],[role="link"],[role="tab"],[tabindex]:not([tabindex="-1"]),input[type=submit],input[type=button],input[type=checkbox],input[type=radio]';
    function tick() {
      x += (tx - x) * 0.24; y += (ty - y) * 0.24;
      c.style.translate = x.toFixed(1) + 'px ' + y.toFixed(1) + 'px';
      raf = (Math.abs(tx - x) > 0.3 || Math.abs(ty - y) > 0.3) ? requestAnimationFrame(tick) : 0;
    }
    var lastT = null, lastHost = null;
    // Faixa/carrossel: ancestral mais próximo com rolagem horizontal real (cobre os do tema sem depender de classe).
    function scrollHost(t) {
      if (t === lastT) return lastHost;
      lastT = t; lastHost = null;
      for (var el = t; el && el !== d.body && el !== d.documentElement; el = el.parentElement) {
        var ox = getComputedStyle(el).overflowX;
        if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 8) { lastHost = el; break; }
      }
      return lastHost;
    }
    function off() { on = false; lastT = null; c.classList.remove('is-on', 'is-link', 'is-card', 'is-field'); }
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; x = tx; y = ty; c.style.translate = x + 'px ' + y + 'px'; c.classList.add('is-on'); }
      var t = e.target && e.target.closest ? e.target : null;
      // Diálogos modais ficam na camada superior: o anel mora no diálogo aberto e volta ao body ao fechar.
      var dlg = t && t.closest('dialog[open]'), home = dlg || d.body;
      if (c.parentNode !== home) home.appendChild(c);
      var field = t && (t.closest(FIELD) || t.closest(ZONES) || scrollHost(t));
      var link = !field && t && t.closest(LINK);
      var card = !field && t && (t.closest('.pg-card,.pg-wp-card,.pg-family,.pg-gallery-open') || (link && link.querySelector && link.querySelector('img,picture')));
      c.classList.toggle('is-field', !!field);
      c.classList.toggle('is-card', !!card);
      c.classList.toggle('is-link', !!link && !card);
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
    d.documentElement.addEventListener('mouseleave', off);
    window.addEventListener('blur', off);
    var onChange = function () { if (mqR.matches) { off(); c.remove(); } };
    if (mqR.addEventListener) mqR.addEventListener('change', onChange);
  }
  function boot() { try { init(); } catch (e) {} }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
